// Libs
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

// Component
import JobsPanel, { Props } from '../components/JobsPanel'

// Selectors and Actions
import { token$ } from 'fc-auth'

import {
  updateFarm,
  updateField,
  subfieldOfField$,
} from 'hfty-assets'

import {
  areaPerAsset$,
} from 'fc-assets'

import {
  // Selectors
  selectedFeatureIndex$,
  hoverFeatureIndex$,
  selectedFieldId$,
  selectedFeatureIndices$,
  selectedFarmId$,
  selectedSeasonId$,
  fieldsOfSelectedFarmAndSeason$,
  isPreviousPointsShown$,

  // Actions
  toggleHoverPoint,
  toggleHoverFeature,
  selectJobFeature,
  showPreviousPoints,
  centerMapToFarm,
  centerMapToField,
} from 'hfty-map'

import soilPropsMapBlobId$ from 'hfty-map-dom/src/selectors/soilPropsMapBlobId'

import {
  jobSelectorOptions$,
  selectedJobAndGrid$,
  previousPoints$,
} from 'hfty-soil-jobs'

import fieldSelectorOptions$ from '../selectors/fieldSelectorOptions'
import farmSelectorOptions$ from '../selectors/farmSelectorOptions'
import userSelectorOptions$ from '../selectors/userSelectorOptions'

import { seasonSelectorOptions$, updateCurrentSeason } from 'hfty-seasons'
import { operations$, operation$, addSoilJob, editSoilJob, selectSoilJob } from 'hfty-soil-jobs-dom'
import { authenticatedUserId$ } from 'fc-authenticated-user'
import featuresOfSoilJob$ from 'hfty-soil-jobs/src/selectors/featuresOfSoilJob'

// Actions
import {
  preselectedJob,
  clearMapUrlFromJobId,
  loadSoilPropsMapData,
} from 'hfty-map-dom'

// Operators
import soilJobsOperator from 'fc-operator-sampling-jobs'

// Local
const mapStateToProps = (state: Object, props: Object): Props => {
  const areaPerAsset = areaPerAsset$(state)
  const selectedFieldId = selectedFieldId$(state)
  const area = areaPerAsset[selectedFieldId] || null
  const selectedFeatureIndices = selectedFeatureIndices$(state)

  return {
    fields: fieldsOfSelectedFarmAndSeason$(state),
    farmSelectorOptions: farmSelectorOptions$(state),
    fieldSelectorOptions: fieldSelectorOptions$(state),
    jobSelectorOptions: jobSelectorOptions$(state),
    seasonSelectorOptions: seasonSelectorOptions$(state),
    selectedSeasonId: selectedSeasonId$(state),
    selectedFarmId: selectedFarmId$(state),
    selectedFeatureIndex: selectedFeatureIndex$(state),
    hoverFeatureIndex: hoverFeatureIndex$(state),
    selectedFieldId,
    selectedJob: selectedJobAndGrid$(state),
    operations: operations$(state),
    operation: operation$(state),
    userId: authenticatedUserId$(state),
    subfield: subfieldOfField$(state),
    assigneeOptions: userSelectorOptions$(state),
    area,
    gridData: props.gridData,
    selectedFeatureIndices: selectedFeatureIndices,
    token: token$(state),
    featuresOfSoilJob: featuresOfSoilJob$(state),
    soilPropsMapBlobId: soilPropsMapBlobId$(state),
    previousPoints: previousPoints$(state),
    isPreviousPointsShown: isPreviousPointsShown$(state),
  }
}

function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      onChangeSeason: updateCurrentSeason,
      onChangeFarm: updateFarm,
      onChangeField: updateField,
      onSelectFeature: selectJobFeature,
      onSelectJob: selectSoilJob,
      onToggleHoverFeature: toggleHoverFeature,
      onAddJob: addSoilJob,
      onEditJob: editSoilJob,
      onSubmitJob: soilJobsOperator.actionCreators.submitOperations,
      onCancelJob: soilJobsOperator.actionCreators.cancelOperations,
      onUpdateJob: soilJobsOperator.actionCreators.updateOperation,
      onHoverSamplingPoint: toggleHoverPoint,
      preselectedJob,
      clearMapUrlFromJobId,
      loadSoilPropsMapData,
      showPreviousPoints,
      centerMapToFarm,
      centerMapToField,
    }, dispatch),
  }
}

// Exports
export default connect(mapStateToProps, mapDispatchToProps)(JobsPanel)
